//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  name: 'CreatePostButton',
  props: {
    displayImportDropdown: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    displayCreatePostModalForAccounts(accounts) {
      this.$createPostForAccounts(accounts)
    },
    displayCreatePostModalForFirstAccount() {
      this.$createPostForAccounts([this.profile.socialAccounts[0]])
    }
  },
  computed: {
    ...mapState(['profile'])
  }
}
